import type { SelectFilterState } from '../../../../../common/constants/filters/select-filter/types';
import { ProductKeys } from '../../../../../common/constants/products';

const projectIdToARI = (cloudId: string, projectId: string) =>
	`ari:cloud:jira:${cloudId}:project/${projectId}`;

export const generateQueryParamsGetState = <ID extends string>(
	initialState: SelectFilterState<ID>,
	queryParamKey: string,
) => {
	return (queryParams: Record<string, string[]>, cloudId: string): SelectFilterState<ID> => {
		const selectedProduct = (queryParams['product'] ?? [])[0];
		const queryParamValue = queryParams[queryParamKey] || [];
		const value =
			selectedProduct === ProductKeys.JiraDC || selectedProduct === ProductKeys.JsmDC
				? queryParamValue
				: queryParamValue.map((projectId) => projectIdToARI(cloudId || '', projectId));

		return {
			...initialState,
			value: value || initialState.value,
		};
	};
};
